import React from 'react';
import { Typography } from 'components/atoms';
import { EmployeeReviewData } from 'components/pages/EmployeeReview';
import './index.scss';

interface Props {
  data: EmployeeReviewData[];
  kpiData?: {
    totalEmployees: number;
    activeGoals: number;
    completedGoals: number;
    avgProgress: number;
    pendingReviews: number;
  };
}

interface KPICardProps {
  title: string;
  count: number;
  color: string;
  icon: string;
}

const KPICard = ({ title, count, color, icon }: KPICardProps) => (
  <div className={`kpi-card ${color}`}>
    <div className="kpi-card-icon">
      <img src={icon} alt={title} />
    </div>
    <div className="kpi-card-content">
      <Typography type="heading4" text={count.toString()} weight="bold" />
      <Typography type="small_regular" text={title} color="gray" />
    </div>
  </div>
);

export const EmployeeReviewKPICards = ({ data, kpiData }: Props) => {
  // Use kpiData if provided, otherwise calculate from data
  const totalEmployees = kpiData?.totalEmployees || data.length;
  const pendingReviews = kpiData?.pendingReviews || data.filter(emp => emp.status === 'pending').length;
  const activeGoals = kpiData?.activeGoals || 0;
  const completedGoals = kpiData?.completedGoals || 0;
  const avgProgress = kpiData?.avgProgress || 0;

  return (
    <div className="employee-review-kpi-cards">
      <KPICard
        title="Total Employees"
        count={totalEmployees}
        color="total"
        icon="/icons/employee.svg"
      />
      <KPICard
        title="Active Goals"
        count={activeGoals}
        color="active"
        icon="/icons/list-check.svg"
      />
      <KPICard
        title="Completed Goals"
        count={completedGoals}
        color="completed"
        icon="/icons/list-check.svg"
      />
      <KPICard
        title="Avg Progress"
        count={avgProgress}
        color="progress"
        icon="/icons/refresh.svg"
      />
      <KPICard
        title="Pending Reviews"
        count={pendingReviews}
        color="pending"
        icon="/icons/clock.svg"
      />
    </div>
  );
}; 